import React, { createContext, useContext, useState } from 'react';

const NavbarContext = createContext();

export function NavbarProvider({ children }) {
  const [navbarHeight, setNavbarHeight] = useState(0);

  return (
    <NavbarContext.Provider value={{ navbarHeight, setNavbarHeight }}>
      {children}
    </NavbarContext.Provider>
  );
}

export function useNavbar() {
  return useContext(NavbarContext);
}
